import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { LoginScreen } from '@/features/auth/LoginScreen';
import { AppShell } from '@/features/shell/AppShell';
import { DashboardScreen } from '@/features/dashboard/DashboardScreen';
import { PlaceholderScreen } from '@/features/shell/PlaceholderScreen';

/** Out-of-scope routes reuse a neutral placeholder inside the shell. */
const PLACEHOLDERS: Array<{ path: string; title: string }> = [
  { path: 'operativa', title: 'Hub operativo' },
  { path: 'avisos', title: 'Avisos · RMS' },
  { path: 'altaAviso', title: 'Registrar aviso' },
  { path: 'asistencias', title: 'Asistencias' },
  { path: 'accidentes', title: 'Accidentes' },
  { path: 'vehiculos', title: 'Vehículos' },
  { path: 'estadisticas', title: 'Estadísticas' },
  { path: 'usuarios', title: 'Usuarios' },
  { path: 'catalogos', title: 'Catálogos' },
  { path: 'configuracion', title: 'Configuración' },
];

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/dashboard" element={<DashboardScreen />} />
        {PLACEHOLDERS.map((p) => (
          <Route
            key={p.path}
            path={`/${p.path}`}
            element={<PlaceholderScreen title={p.title} />}
          />
        ))}
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
